import { Waves, Zap, Moon, Repeat } from "lucide-react";

/** Per-type identity: lime = steady, orange = intervals, faded red = recovery, yellow = rounds. */
export const CARDIO_SESSION_TYPES = [
  { id: 'steady', line1: 'Steady', line2: 'State', desc: 'Consistent pace for endurance',
    color: 'var(--accent-hex)', Icon: Waves },
  { id: 'interval', line1: 'Interval', line2: 'Training', desc: 'Alternating high and low intensity',
    color: '#FF8A1F', Icon: Zap },
  { id: 'recovery', line1: 'Recovery', line2: 'Easy', desc: 'Light pace to aid recovery',
    color: '#E0696B', Icon: Moon },
  { id: 'rounds', line1: 'Rounds', line2: 'Sets', desc: 'Timed work and rest rounds',
    color: '#FFD60A', Icon: Repeat },
];

const hexToRgb = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

export const CardioTypeCards = ({ value, onChange, testIdPrefix = 'cardio-type' }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
    {CARDIO_SESSION_TYPES.map(({ id, line1, line2, desc, color, Icon }) => {
      const active = value === id;
      const rgb = hexToRgb(color);
      return (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          data-testid={`${testIdPrefix}-${id}`}
          className="relative rounded-xl text-left overflow-hidden transition-transform duration-150 active:scale-[0.97]"
          style={{
            border: `1.5px solid ${active ? color : 'rgba(255,255,255,0.10)'}`,
            background: active
              ? `linear-gradient(160deg, rgba(${rgb},0.20) 0%, rgba(${rgb},0.05) 55%, rgba(10,10,10,1) 100%)`
              : '#121212',
            boxShadow: active ? `0 0 0 1px rgba(${rgb},0.35), 0 6px 26px -6px rgba(${rgb},0.55)` : 'none',
          }}
        >
          {active && (
            <span className="cardio-type-beam" style={{ '--ct-glow': color }} aria-hidden="true" />
          )}
          <span className="relative block px-2.5 pt-2.5 pb-3">
            <Icon
              size={14}
              strokeWidth={2.5}
              style={{ color: active ? color : 'rgba(255,255,255,0.35)' }}
            />
            <span
              className="mt-2 block font-heading font-black uppercase text-[13px] leading-[1.02] tracking-[-0.01em]"
              style={{ color: active ? '#FFFFFF' : 'rgba(255,255,255,0.72)' }}
            >
              {line1}
              <br />
              {line2}
            </span>
            <span
              className="mt-1.5 block text-[9px] leading-[1.3] min-h-[36px]"
              style={{ color: active ? `rgba(${rgb},0.85)` : 'rgba(255,255,255,0.38)' }}
            >
              {desc}
            </span>
          </span>
        </button>
      );
    })}
  </div>
);
